import { matchPath } from 'react-router-dom';

import { getPlatformProperties } from 'contexts/analytics/usePlatformProperties';
import { getKitById } from 'store/kits';
import type { RootState } from 'store/store';

// The routes useGetKitIdParam matches from outside the route tree.
const KIT_ROUTE_PATTERNS = [
  '/results/:kitId/*',
  '/action-plan/:kitId/*',
  '/review/:kitId',
];

export const getKitIdFromPath = (pathname: string): string | undefined => {
  for (const pattern of KIT_ROUTE_PATTERNS) {
    const kitId = matchPath(pattern, pathname)?.params.kitId;
    if (kitId) return kitId;
  }
  return undefined;
};

// Read from the URL and the store when the event is sent: autocaptured page
// views fire on pushState, before React re-renders with the new route.
export const getEventContext = (state: RootState, pathname: string) => {
  const kitId = getKitIdFromPath(pathname);
  const kit = kitId ? getKitById(kitId)(state) : undefined;

  return {
    ...getPlatformProperties(),
    path: pathname,
    page: kit ? pathname.replace(`/${kitId}`, '') : pathname,
    ...(kit && {
      kit_id: kit.id,
      sampling_type: kit.sampling_type,
      date_results_ready: kit.date_results_ready,
      age_at_sampling: kit.age_at_sampling,
      is_resample: kit.is_resample,
      sci_version: kit.sci_version,
    }),
  };
};
